import { z } from 'zod';
import { sortablePageParamsSchema } from '#api/common.ts';
import { ObligationStatusCategory } from '#lib/models/enums.ts';
import { GenericApi } from './genericApi';

export const statusSchema = z.object({
    clientId: z.coerce.number().optional(),
    code: z.string(),
    category: ObligationStatusCategory,
    name: z.string(),
    description: z.string(),
    behavior: z.string(),
    updatedUtc: z.coerce.date().optional(),
    createdUtc: z.coerce.date().optional()
});

export const createStatusSchema = z.object({
    clientId: z.coerce.number().optional(),
    code: z
        .string()
        .min(1, 'Code is required')
        .max(10, 'Code must be 10 characters or fewer')
        .regex(/^[a-zA-Z0-9_-]+$/, 'Code may contain only letters, numbers, underscores and hyphens'),
    category: ObligationStatusCategory,
    name: z.string().min(1, 'Name is required').max(50, 'Name must be 50 characters or fewer'),
    description: z.string().optional(),
    behavior: z.string()
});

export const updateStatusSchema = createStatusSchema.partial();

export const listStatusesSchema = sortablePageParamsSchema.extend({
    clientId: z.number().optional()
});

export type Status = z.infer<typeof statusSchema>;
export type CreateStatus = z.infer<typeof createStatusSchema>;
export type UpdateStatus = z.infer<typeof updateStatusSchema>;
export type ListStatuses = z.infer<typeof listStatusesSchema>;

export class StatusApi extends GenericApi<Status, CreateStatus, UpdateStatus, ListStatuses, string> {
    constructor() {
        super('statuses');
    }
}
